export { PriceDetail } from './index.pc'
export { MobilePriceDetail } from './index.mobile'
